import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/cloudP/icn_cp_01.png';
import icn_02 from '../../assets/img/landingPage/cloudP/icn_cp_02.png';
import icn_03 from '../../assets/img/landingPage/cloudP/icn_cloudP_03.png';
import icn_04 from '../../assets/img/landingPage/cloudP/icn_cloudP_04.png';
import icn_05 from '../../assets/img/landingPage/cloudP/icn_cloudP_05.png';
import icn_06 from '../../assets/img/landingPage/cloudP/icn_cloudP_06.png';
import icn_07 from '../../assets/img/landingPage/cloudP/icn_cloudP_07.png';
import icn_08 from '../../assets/img/landingPage/cloudP/icn_cloudP_08.png';

import icn_vision from '../../assets/img/landingPage/about/aboutUs_vision.svg';

import keyfeature01 from '../../assets/img/landingPage/cloud/Cloud_03.png';
import keyfeature02 from '../../assets/img/landingPage/aipowered/aiPowered-02.png';
import keyfeature03 from '../../assets/img/landingPage/meshManager/MeshManager03.png';
import keyfeature04 from '../../assets/img/landingPage/virtualServer/VS_0.png'
import keyfeature05 from '../../assets/img/landingPage/integration/integration-02.png';

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/automation/Automation_dashboard.png';


const AIPowered = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'AI-ready APIs and microservices',
            text: "Define and orchestrate intelligent, composable services that feed AI models.",
            altDescription: "Define and orchestrate intelligent, composable services that feed AI models.",
            image: keyfeature01,
        },
        Key_Feature_02: {
            title: "Seamless integration with AI ecosystems",
            text: "Connect with LLMs, RPA, AI Ops, BPM, and context-aware data pipelines.",
            altDescription: "Connect with LLMs, RPA, AI Ops, BPM, and context-aware data pipelines.",
            image: keyfeature02,
        },
        Key_Feature_03: {
            title: 'Smart orchestration and decision flows',
            text: 
            "Enable adaptive workflows with AVAP Virtual Server and AVAP Mesh Manager.",
            altDescription: 'Enable adaptive workflows with AVAP Virtual Server and AVAP Mesh Manager.',
            image: keyfeature03,
        },
        Key_Feature_04: {
            title: 'Data-rich, semantically-aware design',
            text: 
            "Enrich APIs with contextual data (via MCP) to improve AI outcomes.",
            altDescription: 'Enrich APIs with contextual data (via MCP) to improve AI outcomes.',
            image: keyfeature04,
        },
        Key_Feature_05: {
            title: 'Infrastructure for internal copilots',
            text: 
            "Prepare your architecture for AI copilots across business functions.",
            altDescription: 'Prepare your architecture for AI copilots across business functions.',
            image: keyfeature05,
        },
    }

    //Key UseCases Bento
    const items2 = [
        {
        
            title: 'Customer Experience',
            paragraphs: [
              'Smart assistants, copilots, chatbots, and voicebots for contextual support.'
            ]
          },
        {
        
            title: 'Supply Chain',
            paragraphs: [
              'Predictive models for inventory, logistics, and resource optimization.'
            ]
          },
        {
         
          title: 'Finance & Risk',
          paragraphs: [
            'Intelligent fraud detection, automated reconciliation, and credit scoring.',
          ]
        },
        {
           
            title: 'Public Sector',
            paragraphs: [
              'AI-driven case management, policy evaluation, and citizen services.',
            ]
        },  
        {
           
            title: 'Software Development',
            paragraphs: [
              'Code generation, testing, and continuous validation powered by AI copilots.',
            ]
        },  
        {
           
            title: 'Healthcare',
            paragraphs: [
              'AI-assisted diagnostics, patient journey orchestration, and predictive care delivery models.',
            ]
        },        
      ];
      
    const breakpointColumnsObj2 = {
        default: 3, //Cambio de columnas verticales
        1100: 3,
        700: 1          
    };
    
    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center pt-5">
                    <h1 className="fl-title-big m-0">AI-Powered Digital Transformation</h1>
                    <p className="fl-title gradient-text fl-txt-container-s">Transform faster. Smarter. With AI-ready Virtual APIs and microservices built on AVAP.</p>
                </section>

                {/* Subtítulo descripción */}
                 <section className="text-center pb-5">
                    <img
                        src={dashboard}
                        className="img-fluid mt-0"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />
                        <br />
                        <h2 className='fl-subtitle pt-8'>Rethink What Digital Means, With AI at the Core</h2>
                                <p className="fl-text fl-txt-container-s" >
                                AI-Powered Digital Transformation is more than digitizing what already exists. It’s about reimagining operations, customer experiences, and business models by putting artificial intelligence at the center of how your organization works, learns, and evolves.
                                </p>
                                <p className="fl-text fl-txt-container-s" >
                                AVAP Framework gives you the composable, API-centric foundation to connect, orchestrate, and scale intelligent processes, making AI transformation actionable, secure, and enterprise-ready.
                                </p>
                        {/*Boton Contact Us*/}  
                         <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                </section>

                  
                <div className="container text-center fl-card-border p-6">
                    <h2 style={{ marginTop: '40px' }} className="fl-title m-0 gradient-text fl-title m-4">Why AI-Powered Digital Transformation?</h2>
                    <br/>
                    <p className="fl-subtitle"><p/> 
                    {/* Sección Bullets */}
                    <ul className="fl-text fl-txt-container-s">
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}>Smarter decisions:</strong> Predictive models powered by real-time and historical data.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}>Greater efficiency: </strong> Automate complex or repetitive tasks across your value chain.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}>Deeper personalization:</strong> Deliver tailored services and experiences in real time.</li>
                        <li className="fl-bullets"><strong style= {{fontWeight:600}}>Scalable intelligence:</strong> Deploy systems that learn and adapt, built to grow with your needs.</li>
                    </ul>
                    </p>
                </div>

                 {/*Sección where it applies - bento */}
                 <div className="container my-5">
                <div className="fl-title text-center mb-6">
                Where It Applies
                </div>
            
                    <Masonry
                    breakpointCols={breakpointColumnsObj2}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items2.map((item2, idx) => (
                        <div key={idx} className="grayBox fl-card-s text-center">
                        <p className="fl-subtitle-xs">{item2.title}</p>
                        {item2.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>

                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0">AVAP Framework: Built for AI-Driven Architecture</p> 
                            <p className='pt-3 fl-txt-container-s text-center'>AVAP was designed to help companies move beyond traditional digitalization, toward intelligent systems that think, adapt, and scale. Here’s how it fits:</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a> 
                            </div>
                        </section>
                    </div>
                </div>

               {/* Sección Key Use Cases */}   
              {/* <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                            Key Use Cases
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                Public Sector:
                                </p>
                                <p className="fl-text">
                                Automate complex services (e.g., identity verification, benefit disbursement) using reusable API workflows.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                               
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Enterprises:
                                </p>
                                <p className="fl-text">
                                Launch new digital offerings by composing from existing microservices.
                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                               
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Innovation Teams:
                                </p>
                                <p className="fl-text">
                                Rapidly prototype and deploy modular capabilities.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                               
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Modernization Projects:
                                </p>
                                <p className="fl-text">
                                Migrate from monolithic architectures to flexible, API-first systems.
                                </p>
                            </div>
                        </div>
                    </div>
                </section> */}

               
                
                {/* leyenda */} 
                {/*<section className="container py-10">
                    <h1 className='fl-subtitle text-center  gradient-text'>"Composable architecture lets you adapt as fast as your environment changes. AVAP gives you the control, speed, and structure to make it happen."</h1>
                </section>*/}

                {/* Sección built for secure */} 
                {/*<section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="rightBC">
                                    <h3 className='fl-title'>Built for Enterprise Transformation</h3>
                                    <p>AVAP aligns with the architectural vision championed by Gartner, Salesforce, Oracle, and others—bringing those capabilities within reach for businesses of any size.
                                    Compose. Deploy. Scale — with AVAP.
                                    </p>
                                    <br/>
                                    <p className='bold'>Compose. Deploy. Scale — with AVAP.
                                    </p> 
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </section>*/}

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default AIPowered;
